import React from 'react';
import { Image } from 'app/components/Image';
import { TextField, FormControl } from '@material-ui/core';
import { useSelector } from 'react-redux';
import classNames from 'clsx';

import { getQuotationPhoneNumber } from 'app/store/data/quotation';
import { Alert } from 'app/components/Alert';
import { MessageTypeEnum, InstallmentsEnum } from 'app/shared/enums';
import { NewButton } from 'app/components/NewButton';
import { selectIsFormMicroCenterActive } from 'app/store/selectors/selectIsFormMicroCenterActive';

import { ApplicationSmsFormProps } from './ApplicationSmsForm.interface';
import { useStyles } from './ApplicationSmsForm.styles';
import useApplicationSmsForm from './useApplicationSmsForm';

export default function ApplicationSmsForm(props: ApplicationSmsFormProps) {
  const classes = useStyles();
  const { btnContent, imgName, isConfirmApplication } = props;
  const phoneNumber = useSelector(getQuotationPhoneNumber);
  const isFormMicroCenterActive = useSelector(selectIsFormMicroCenterActive);

  const {
    sendCodeAgain,
    onSubmitForm,
    value,
    handleOnChange,
    canSendAgain,
    isSmsNotValid,
    alertError,
    isLoading,
  } = useApplicationSmsForm(isConfirmApplication);

  return (
    <FormControl fullWidth>
      {alertError && (
        <Alert
          className={classes.errorAlert}
          title={InstallmentsEnum.SmsErrorResentTitle}
          text={InstallmentsEnum.SmsErrorResent}
          type={MessageTypeEnum.Danger}
          dataCy="sms-error-alert-send-again"
        />
      )}
      <div className={classes.contentWrapper}>
        <div className={classes.imgWrapper}>
          <Image
            src={`./images/mubi-installments/${imgName}.png`}
            srcSet={`./images/mubi-installments/${imgName}.png`}
            srcSetWebp={`./images/mubi-installments/${imgName}.webp,`}
            alt={'sms form'}
            className={classes.img}
          />
        </div>

        <TextField
          id={`confirm-sms-number`}
          value={value}
          onChange={handleOnChange}
          label={InstallmentsEnum.SmsCode}
          variant={'outlined'}
          className={classes.textField}
          inputProps={{
            inputMode: 'numeric',
            className: classes.input,
            maxLength: 4,
          }}
          name="confirmSmsNumber"
          error={isSmsNotValid}
          helperText={isSmsNotValid ? InstallmentsEnum.WrongSmsCode : ''}
        />
        <div className={classes.textInfo}>
          {InstallmentsEnum.SmsCodeWasSend}{' '}
          <b>
            {'+48'}&nbsp;{`${phoneNumber}`}
          </b>
        </div>
        <div
          className={classNames(classes.textAction, {
            [classes.disable]: !canSendAgain,
          })}
          onClick={sendCodeAgain}
        >
          {InstallmentsEnum.SendSmsCodeAgain}
        </div>
      </div>
      <NewButton
        onClick={onSubmitForm}
        isLoading={isLoading}
        fullWidth
        title={btnContent}
        variant="contained"
        color="primary"
        className={classes.submitButton}
        data-cy="confirm-sms-number-btn"
        rounded={isFormMicroCenterActive}
      />
    </FormControl>
  );
}
